import MoreMenuMobileDropdown from './MoreMenuMobileDropdown';
import MoreMenuMobileDropdownContainer from './MoreMenuMobileDropdown.container';
export default MoreMenuMobileDropdownContainer(MoreMenuMobileDropdown);

//# sourceMappingURL=index.js.map